import { render, staticRenderFns } from "./ClassNewForm.vue?vue&type=template&id=2daa5240"
import script from "./ClassNewForm.vue?vue&type=script&lang=js"
export * from "./ClassNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports